var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"notFound"}},[_c('img',{staticClass:"mx-auto d-block",attrs:{"src":require("../assets/img/404.png")}})])}]

export { render, staticRenderFns }